import React from 'react';
import { Icons, SVG } from '../../../../components/atoms/SVG';
import { PageMembershipStatus } from '../../../../types/api/PageMembershipStatus';
import Bem from '../../../../lib/bemUtils/bem';

type NavIconType = {
  status: PageMembershipStatus;
};

export function NavIcon({ status }: NavIconType) {
  return (
    <span className={Bem('main-navigation__navitem-iconcontainer', status === 'active' ? 'personal' : undefined)}>
      <SVG inverted svgSpriteId={status === 'active' ? Icons.USER_PAL : Icons.ASSIGNMENT_PENDING} />
    </span>
  );
}
